import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { formatMoney, testEmpty } from '../../../library/helpers/utility';
import { Combustiveis } from '../../../library/helpers/sharedData';

const styles = StyleSheet.create({
    reportTitle:{
        fontSize: 10,
        marginTop: 5,
        fontFamily: 'Helvetica-Bold',
        textIndent:'5px'
    },
    container:{
        // paddingTop:'0px',
        // paddingLeft:'0px',
        // paddingRight:'0px',
        fontSize:10,
        flexDirection: 'row',
        fontWeight:'normal',
        border: '1px solid #000000',
        borderRadius:'3px'
    },
    text:{
        fontSize: 10,
        whiteSpace: 'pre-line'
    }
});

const ProposalVehicle = ({ vehicle }) => {
    return (
        <>
            <Text style={styles.reportTitle}>Veículo</Text>
            <View style={styles.container}>
                <View style={{ width: '534px', flexDirection: 'column', textAlign: 'center', textTransform:'uppercase', fontSize: 8 }}>
                    <View style={{ width: '534px', flexDirection: 'row', padding: '0 2px 0 2px' }}>
                        <Text style={{ width: '70px', fontFamily: 'Helvetica-Bold', borderRight: '1px #DDD solid' }}>Placa</Text>
                        <Text style={{ width: '70px', borderRight: '1px #DDD solid' }}>{`${vehicle.placa}`}</Text>
                        <Text style={{ width: '70px', fontFamily: 'Helvetica-Bold', borderRight: '1px #DDD solid' }}>Marca/mod</Text>
                        <Text style={{ width: '248px', borderRight: '1px #DDD solid' }}>{`${vehicle.marca}/${vehicle.modelo}`}</Text>
                        <Text style={{ width: '35px', fontFamily: 'Helvetica-Bold', borderRight: '1px #DDD solid' }}>Cor</Text>
                        <Text style={{ width: '80px'}}>{`${vehicle.cor}`}</Text>
                    </View>
                    <View style={{ width: '534px', flexDirection: 'row', borderTop: '1px #DDD solid', padding: '0 2px 0 2px', marginTop: '0px' }}>
                        <Text style={{ width: '70px', fontFamily: 'Helvetica-Bold', borderRight: '1px #DDD solid' }}>Ano fab.</Text>
                        <Text style={{ width: '70px', borderRight: '1px #DDD solid' }}>{`${vehicle.ano_fab}`}</Text>
                        <Text style={{ width: '70px', fontFamily: 'Helvetica-Bold', borderRight: '1px #DDD solid' }}>Ano mod.</Text>
                        <Text style={{ width: '70px', borderRight: '1px #DDD solid' }}>{`${vehicle.ano_mod}`}</Text>
                        <Text style={{ width: '40px', fontFamily: 'Helvetica-Bold', borderRight: '1px #DDD solid' }}>Comb.</Text>
                        <Text style={{ width: '139px', borderRight: '1px #DDD solid' }}>{`${Combustiveis[vehicle.combustivel]}`}</Text>
                        <Text style={{ width: '35px', fontFamily: 'Helvetica-Bold', borderRight: '1px #DDD solid' }}>km</Text>
                        <Text style={{ width: '80px' }}>{`${formatMoney(vehicle.odo, {significantDigits: 0, decimalSeparator: ''})}`}</Text>
                    </View>
                    <View style={{ width: '534px', flexDirection: 'column', borderTop: '1px #DDD solid', padding: '2px', marginTop: '0px', textAlign:'left' }}>
                        {
                            testEmpty(vehicle.obs, '') !== '' ?
                                <>
                                    <Text style={{ width: '532px', fontFamily: 'Helvetica-Bold' }}>Observações do veículo:</Text>
                                    <Text style={{ width: '532px', textTransform: 'none' }}>
                                        {vehicle.obs}
                                    </Text>
                                </>
                            : ''
                        }
                    </View>
                </View>
            </View>
        </>
    );
}

export default ProposalVehicle